import { useNovaApi } from 'novaApi/useNovaApi';

export const useUserRoles = () => {
  return (
    useNovaApi<Nl.Api.UserRolesResponse>('/user_role', { staleTime: Infinity })
      .data?.user_roles ?? []
  );
};
